/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description React Hook useGetEntityWorklists - fetches paginated worklists for an entity
 */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';

interface IProps {
	entityType: ClaimWorkLists.IWorkListEntityType;
	entityId: string;
	pgNum?: number;
	pgSize?: number;
}

const useGetEntityWorklists = (): UseMutationResult<ClaimWorkLists.IPaginatedEntityWorklists, IAxiosError, IProps, unknown> => {
	return useMutation({
		mutationFn: async ({ entityType, entityId, pgNum, pgSize }) => {
			const { data } = await api.WorklistEntityApi.getEntityWorklists({ entityType, entityId, pgNum, pgSize });
			return data;
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useGetEntityWorklists;
